import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';
import { LayoutProps, SpaceProps, layout, space } from 'styled-system';

const ThinDivider = styled.div<LayoutProps & SpaceProps>`
  border-bottom: 1px solid ${tokens.colors.gray};
  width: 100%;

  ${layout};
  ${space};
`;

export default ThinDivider;
